const OPERATION_KEY = '__pdxNetworkOperation';

/**
 * Tags a transport-failure error with the GraphQL operation that produced it.
 * graphql-request throws fetch rejections past its response middleware, so the
 * only place the operation is known is the fetch wrapper — this carries it on
 * the error so the reporter can attribute and fingerprint the failure later.
 */
export const attachNetworkOperation = (
  error: Error,
  operationName: string,
): void => {
  Object.defineProperty(error, OPERATION_KEY, {
    value: operationName,
    enumerable: false,
    configurable: true,
  });
};

export const getNetworkOperation = (error: Error): string | undefined => {
  const value = (error as unknown as Record<string, unknown>)[OPERATION_KEY];
  return typeof value === 'string' ? value : undefined;
};

/**
 * graphql-request POSTs `{ query, variables, operationName }`; the fetch wrapper
 * only sees the serialized body, so this recovers the operation name from it.
 */
export const operationNameFromRequestBody = (
  body: BodyInit | null | undefined,
): string | undefined => {
  if (typeof body !== 'string') {
    return undefined;
  }
  try {
    const parsed = JSON.parse(body) as { operationName?: unknown };
    return typeof parsed.operationName === 'string'
      ? parsed.operationName
      : undefined;
  } catch {
    return undefined;
  }
};
